import {React,useState} from 'react';
// import './App.css';
import KeyValueGrid from './KeyValueGrid';
import Navbar from './components/Navbar';
import { Routes,Route, Router } from 'react-router-dom';
import About from './components/About';
import Central from './components/Central';
function App() {

  return (
    
     <>
     <Navbar />
   
   <Routes>
   <Route path='/' element={<Central />} />
    <Route path='/about' element={<About  />} />
  </Routes>
    </>
    
  );
}

export default App;
